
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'expressstopIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'expressstop',
				windowName: '快递停用',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
